import { useFeatureToggleClient } from '@40seas/frontend/libs/providers';
import React, { Suspense } from 'react';

const LazyChatAssistantProvider = React.lazy(() => import('./LazyChatAssistantProvider'));

interface ChatAssistantProviderProps {
    children: React.ReactNode;
}

export const ChatAssistantProvider = ({ children }: ChatAssistantProviderProps) => {
    const featureToggleClient = useFeatureToggleClient();

    if (!featureToggleClient.conduct('ai-assistant')) {
        return children;
    }

    return (
        <Suspense>
            <LazyChatAssistantProvider>{children}</LazyChatAssistantProvider>
        </Suspense>
    );
};
